import { AlertTriangle, BadgeCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { formatPersianNumber as numberFormatter } from "../../utils/persianNumber";

const planLabels = {
  free: "بسته رایگان",
  professional: "بسته حرفه‌ای",
  premium: "بسته ویژه",
};

const dateFormatter = new Intl.DateTimeFormat("fa-IR", { year: "numeric", month: "2-digit", day: "2-digit" });

// A single compact row: the plan only needs attention when it is expiring or
// inactive, so it stays quiet otherwise.
export default function SubscriptionStatusCard({ subscription, error }) {
  if (error || !subscription) {
    return (
      <aside className="rounded-2xl border border-gray-200 bg-white px-4 py-3" aria-label="وضعیت اشتراک">
        <p className="text-xs text-gray-500">اطلاعات اشتراک در حال حاضر در دسترس نیست.</p>
      </aside>
    );
  }

  const expired = subscription.isExpired || subscription.status === "expired";
  const inactive = subscription.status === "inactive";
  const closeToExpiry = !expired && subscription.daysRemaining != null && subscription.daysRemaining <= 14;
  const requiresAction = expired || inactive || closeToExpiry;
  const Icon = requiresAction ? AlertTriangle : BadgeCheck;

  let detail = "فعال";
  if (expired) detail = "منقضی شده";
  else if (inactive) detail = "غیرفعال";
  else if (subscription.daysRemaining != null) detail = `${numberFormatter(subscription.daysRemaining)} روز باقی‌مانده`;
  else if (subscription.expiresAt) detail = `انقضا ${dateFormatter.format(new Date(subscription.expiresAt))}`;
  else if (subscription.plan === "free") detail = "بدون تاریخ انقضا";

  return (
    <aside
      className={`flex items-center gap-3 rounded-2xl border px-4 py-3 ${requiresAction ? "border-amber-200 bg-amber-50/60" : "border-gray-200 bg-white"}`}
      aria-label="وضعیت اشتراک"
    >
      <Icon size={18} className={`shrink-0 ${requiresAction ? "text-amber-700" : "text-secondary"}`} aria-hidden="true" />
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-bold text-accent">{planLabels[subscription.plan] || subscription.plan}</p>
        <p className={`text-xs ${requiresAction ? "font-semibold text-amber-800" : "text-gray-500"}`}>{detail}</p>
      </div>
      <Link
        to="/dashboard/pricing"
        className={`shrink-0 text-xs font-bold hover:underline ${requiresAction ? "text-amber-800" : "text-primary"}`}
      >
        {requiresAction ? "تمدید بسته" : "ارتقا"}
      </Link>
    </aside>
  );
}
